import Buypoint from '@/pages/Buypoint/Buypoint'
import Account from '@/pages/Buypoint/Account'
import Cart from '@/pages/Buypoint/Cart'
import Checkout from '@/pages/Buypoint/Checkout'
import Orders from '@/pages/Buypoint/Orders'
import Order from '@/pages/Buypoint/Order'
export default {
    path: '',
    component: Buypoint,
    children: [
        {
            path: '/account',
            name: 'Account',
            component: Account,
        },
        {
            path: '/cart',
            name: 'Cart',
            component: Cart,
        },
        {
            path: '/checkout',
            name: 'Checkout',
            component: Checkout,
        },
        {
            path: '/orders',
            name: 'Orders',
            component: Orders,
        },
        {
            path: '/order',
            name: 'Order',
            component: Order,
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/buypoint.js